import React, { useId } from 'react';
import styled from 'styled-components';

import { Icon } from '../Icon';

const StyledLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  font-weight: 500;
  font-size: var(--fs-b3);
  line-height: 1.3;
  color: var(--c-fg-0);

  .box {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-top: 2px;
    border-radius: 6px;
    box-sizing: border-box;
    border: 1px solid ${(p) => (p.checked ? 'var(--c-fg-0)' : 'var(--c-input-border-unfocused)')};
    background: ${(p) => (p.checked ? 'var(--c-fg-0)' : 'transparent')};
    transition: 0.15s;
  }

  &:hover .box {
    border-color: var(--c-fg-0);
  }
`;

const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
  &:focus + .box {
    outline: 1px solid var(--c-fg-0);
    outline-offset: 2px;
  }
`;

const StyledHelp = styled.p`
  margin: 6px 0 0 32px;
  font-weight: 400;
  font-size: var(--fs-fp);
  line-height: 1.4;
  color: var(--c-fg-1);
`;

export interface CheckboxProps {
  label: React.ReactNode;
  checked?: boolean;
  onChange: (checked: boolean) => void;
  /** Sits under the label, in fine print. */
  help?: React.ReactNode;
  name?: string;
}

export function Checkbox({ label, checked, onChange, help, name }: CheckboxProps) {
  const id = useId();

  return (
    <div>
      <StyledLabel checked={!!checked} htmlFor={id}>
        <StyledInput
          type="checkbox"
          id={id}
          name={name}
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="box" aria-hidden="true">
          {checked && <Icon type="Checkmark" size={14} color="var(--c-bg)" />}
        </span>
        <span>{label}</span>
      </StyledLabel>
      {!!help && <StyledHelp>{help}</StyledHelp>}
    </div>
  );
}
